// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';

export default class RenameStack extends Modal {

    state = {
        path: "",
        alert: false
    }

    componentDidMount = () => {
        this.setCurrentPath(this.props.data);
    }

    componentWillReceiveProps = (next) => {
        if (next.data !== this.props.data)
            this.setCurrentPath(next.data);
    }

    setCurrentPath = (data) => {
        this.setState({ path: data && data.relativePath ? data.relativePath : "" });
    }

    renameStack = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const stack = this.props.data;
        const path = this.state.path;

        if (!path || path === "")
            return this.alert();

        await this.setState({ path: "" });

        const root = stack.path.substring(0,stack.path.length - stack.relativePath.length);

        this.props.modal();
        await this.props.rename(stack, root + path);
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <div style={{
                height: 150
            }} />

            <h1>Rename your stack</h1>

            <p>Enter a new name for your stack and hit the <strong>Submit</strong> button to confirm.</p>

            <br />

            <form
                onSubmit={this.renameStack}
            >

                <input
                    id="name"
                    name="name"
                    type="text"
                    className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                    placeholder="Enter new name..."
                    style={{ width: 330 }}
                    value={this.state.path}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ path: e.target.value.replace(/\//g, ""), alert: false })}
                />

                <input
                    type="submit"
                    value="Submit"
                    className="input-inline-submit"
                />
            
            </form>
            
        </div>);
    }

};